import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import {CardProps} from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import {alpha, useTheme} from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CustomPopover, {usePopover} from 'src/components/custom-popover';
import {bgGradient} from 'src/theme/css';
import {ColorSchema} from 'src/theme/palette';
import Iconify from 'src/components/iconify';
import MenuItem from '@mui/material/MenuItem';
import { on } from 'events';

// ----------------------------------------------------------------------

interface Props extends CardProps {
  title: string |any;
  total: string |any;
  value?: string |any;
  icon?: React.ReactNode;
  color?: ColorSchema;
  onPreview: (selectedDetails: any) => void;
  onEdit: (selectedDetails: any) => void;
  onDelete: (selectedDetails: any) => void;
}

export default function FeedbackCardcomponent({
  title,
  total,
  icon,
  color = 'primary',
  value,
  onPreview,
  onEdit,
  onDelete,
  sx,
  ...other
}: Props) {
  const theme = useTheme();
  const popover = usePopover();
  return (
    <Stack
      sx={{
        ...bgGradient({
          direction: '135deg',
          startColor: alpha(theme.palette[color].light, 0.2),
          endColor: alpha(theme.palette[color].main, 0.2)
        }),
        minWidth: '30vh',
        minHeight: 5,
        paddingBottom: 2,
        px: 2,
        borderRadius: 2,
        marginTop: 0.5,
        color: `${color}.darker`,
        backgroundColor: 'common.white',
        ...sx
      }}
      {...other}>
      {icon && <Box sx={{width: 64, height: 64, mb: 1}}>{icon}</Box>}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
        <Typography variant="h3">{title}</Typography>
        <IconButton
          color={popover.open ? 'inherit' : 'default'}
          onClick={popover.onOpen}>
          <Iconify icon="eva:more-horizontal-fill" />
        </IconButton>
      </div>
      <Typography variant="subtitle2" sx={{opacity: 0.64}}>
        {total}
      </Typography>

      <CustomPopover
        open={popover.open}
        onClose={popover.onClose}
        arrow="top-right"
        sx={{width: 160}}>
        <MenuItem
          onClick={() => {
            popover.onClose();
            onPreview(value)
          }}>
          Preview
        </MenuItem>

        <MenuItem
          onClick={() => {
            popover.onClose();
            onEdit(value)
          }}>
          Edit
        </MenuItem>
        {/* <MenuItem
          onClick={() => {
            popover.onClose();
            onDelete(value)
          }}>
          Delete
        </MenuItem> */}
        {/* <Divider sx={{borderStyle: 'dashed'}} /> */}
      </CustomPopover>
    </Stack>
  );
}
